import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import LayoutAuth from "../../components/layoutAuth";
import { authService } from "../../services/auth";
import { trackEvent } from "../../utils/tracking";
import { getParameterByName } from "../../utils/urls";

const ResetPasswordConfirm = () => {
  const [uid, setUid] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setUid(getParameterByName("uid", window.location.href));
    setToken(getParameterByName("token", window.location.href));
  }, []);

  const submitForm = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const newPassword = e.target.elements["new_password"].value;
    const newPasswordConfirm = e.target.elements["new_password_confirm"].value;

    if (newPassword !== newPasswordConfirm) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    authService.confirmPasswordReset(
      uid,
      token,
      newPassword,
      newPasswordConfirm,
      () => {
        setSuccess(true);
        setLoading(false);
        trackEvent('change_password');
      },
      (err, response) => {
        const msg = response?.data?.error || "Could not reset password";
        setError(msg);
        setLoading(false);
      }
    );
  };

  if (!uid || !token) {
    return (
      <LayoutAuth title="Reset your password" subtitle="Invalid or expired link.">
        <p className="text-sm text-theme-text">
          This reset link is invalid or has expired. Please{" "}
          <Link to="/reset-password/" className="font-medium text-theme-primary hover:opacity-80">
            request a new one
          </Link>
          .
        </p>
      </LayoutAuth>
    );
  }

  if (success) {
    return (
      <LayoutAuth title="Password reset" subtitle="Your password has been updated.">
        <Link
          to="/login/"
          className="inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-theme-button focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme-primary"
          style={{ backgroundColor: "var(--theme-primary)" }}
        >
          Sign in
        </Link>
      </LayoutAuth>
    );
  }

  return (
    <LayoutAuth
      title="Set new password"
      subtitle="Enter your new password below."
    >
      <form className="space-y-6" action="#" onSubmit={submitForm}>
        {error ? (
          <div className="rounded-md p-4 border border-red-500 border-opacity-50 bg-red-500 bg-opacity-10">
            <p className="text-sm text-red-500">{error}</p>
          </div>
        ) : null}

        <div>
          <label
            htmlFor="new_password"
            className="block text-sm font-medium text-theme-text"
          >
            New password
          </label>
          <div className="mt-1">
            <input
              id="new_password"
              name="new_password"
              type="password"
              autoComplete="new-password"
              required
              placeholder="Enter new password"
              className="appearance-none block w-full px-3 py-2 border border-theme-secondary rounded-md bg-theme-main shadow-sm text-theme-text placeholder-opacity-60 focus:outline-none focus:ring-theme-primary focus:border-theme-primary sm:text-sm"
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="new_password_confirm"
            className="block text-sm font-medium text-theme-text"
          >
            Confirm new password
          </label>
          <div className="mt-1">
            <input
              id="new_password_confirm"
              name="new_password_confirm"
              type="password"
              autoComplete="new-password"
              required
              placeholder="Confirm new password"
              className="appearance-none block w-full px-3 py-2 border border-theme-secondary rounded-md bg-theme-main shadow-sm text-theme-text placeholder-opacity-60 focus:outline-none focus:ring-theme-primary focus:border-theme-primary sm:text-sm"
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="cursor-pointer w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-theme-button focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme-primary"
            disabled={loading}
            style={{
              backgroundColor: "var(--theme-primary)",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Resetting..." : "Reset password"}
          </button>
        </div>

        <div className="text-center text-sm">
          <Link
            to="/login/"
            className="font-medium text-theme-primary hover:opacity-80"
          >
            Back to sign in
          </Link>
        </div>
      </form>
    </LayoutAuth>
  );
};

export default ResetPasswordConfirm;
